import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { Button } from '../components/ui/button';
import { Sun, Moon, Wrench, Mail, Clock } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Manutencao = () => {
  const { theme, toggleTheme } = useTheme();
  const [logoUrl, setLogoUrl] = useState(null);
  const [nomeEmpresa, setNomeEmpresa] = useState('');
  const [mensagem, setMensagem] = useState('Sistema em manutenção. Voltaremos em breve.');

  useEffect(() => {
    // Carregar logo
    const img = new Image();
    img.src = `${API_URL}/api/empresa/logo?t=${Date.now()}`;
    img.onload = () => setLogoUrl(img.src);
    img.onerror = () => setLogoUrl(null);

    // Carregar nome
    fetch(`${API_URL}/api/empresa/public-info`)
      .then(r => r.json())
      .then(data => { if (data.nome_empresa) setNomeEmpresa(data.nome_empresa); })
      .catch(() => {});

    // Carregar mensagem de manutenção
    fetch(`${API_URL}/api/manutencao/status`)
      .then(r => r.json())
      .then(data => { if (data.mensagem) setMensagem(data.mensagem); })
      .catch(() => {});

    // Verificar periodicamente se saiu da manutenção
    const interval = setInterval(() => {
      fetch(`${API_URL}/api/manutencao/status`)
        .then(r => r.json())
        .then(data => {
          if (!data.manutencao) {
            window.location.href = '/login';
          }
        })
        .catch(() => {});
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="manutencao-page">
      {/* Theme toggle */}
      <div className="absolute top-6 right-6">
        <Button variant="ghost" size="icon" onClick={toggleTheme} className="rounded-full">
          {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </Button>
      </div>

      <div className="max-w-lg w-full text-center space-y-8">
        {/* Logo */}
        {logoUrl ? (
          <img src={logoUrl} alt="Logo" className="w-20 h-20 mx-auto object-contain" />
        ) : (
          <div className="w-20 h-20 mx-auto bg-primary rounded-xl flex items-center justify-center">
            <Wrench className="w-10 h-10 text-primary-foreground" />
          </div>
        )}

        {nomeEmpresa && (
          <h2 className="text-lg font-semibold text-muted-foreground">{nomeEmpresa}</h2>
        )}

        {/* Ícone animado */}
        <div className="relative mx-auto w-24 h-24">
          <div className="absolute inset-0 rounded-full bg-amber-500/10 animate-ping" style={{ animationDuration: '2s' }} />
          <div className="relative w-24 h-24 rounded-full bg-amber-500/20 flex items-center justify-center">
            <Wrench className="w-12 h-12 text-amber-600 dark:text-amber-400" />
          </div>
        </div>

        <div className="space-y-3">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">
            Sistema em Manutenção
          </h1>
          <p className="text-muted-foreground text-base sm:text-lg max-w-md mx-auto">
            {mensagem}
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
          <Clock className="w-4 h-4" />
          <span>O sistema voltará automaticamente quando a manutenção terminar</span>
        </div>

        {/* Suporte */}
        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Mail className="w-4 h-4" />
            <span>Suporte: </span>
            <a href="mailto:suporte@agrolinkbr.com.br" className="text-primary hover:underline font-medium">
              suporte@agrolinkbr.com.br
            </a>
          </div>
        </div>

        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} AgroLinkBR - Todos os direitos reservados
        </p>
      </div>
    </div>
  );
};

export default Manutencao;
